var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',{staticClass:"nav"},[_vm._t("beforeNav"),_vm._t("default"),_vm._t("afterNav")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }